import { Editor } from '@meitu/saas-editor-core';
import tablePresets from '@meitu/saas-editor-core/es/layers/table-layer/presets';
import './table-preset-list.less';

interface ITablePresetListProps {
    editor: Editor;
    currentRecordId?: number;
}

const TablePresetList: React.FC<ITablePresetListProps> = ({ editor, currentRecordId }) => {
    const add = (presetId: string) => {
        editor.tableLayer.addTableLayerByPreset(presetId);
    };

    return (
        <ul className="table-preset-list">
            {tablePresets.map(({ preview, id }) => (
                <li key={id} className="table-preset" onClick={() => add(id)}>
                    <div style={{ backgroundImage: `url("${preview}")` }}></div>
                </li>
            ))}
        </ul>
    );
};

TablePresetList.displayName = 'TablePresetList';

export default TablePresetList;
